import { CreateReplyDto } from '@diritto/common/reply/dtos/create-reply.dto';
import { ReplyResponseDto } from '@diritto/common/reply/dtos/reply.response.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class EpisodeReplyApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async createReply(contentId: number, episodeId: number, data: CreateReplyDto): Promise<ReplyResponseDto> {
    const res = await this.http.post<CreateReplyDto, ReplyResponseDto>(
      `${this.url}/contents/${contentId}/episodes/${episodeId}/reply`,
      data,
    );
    return res.data;
  }
}
